import { render, staticRenderFns } from "./r-stash-bonus-bunch-view.vue?vue&type=template&id=e0367630"
import script from "./r-stash-bonus-bunch-view.vue?vue&type=script&lang=js"
export * from "./r-stash-bonus-bunch-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0367630')) {
      api.createRecord('e0367630', component.options)
    } else {
      api.reload('e0367630', component.options)
    }
    module.hot.accept("./r-stash-bonus-bunch-view.vue?vue&type=template&id=e0367630", function () {
      api.rerender('e0367630', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/stash/r-stash-bonus-bunch-view.vue"
export default component.exports